import { ArgsParser } from "@/lib/args/args-parser";

export const args = new ArgsParser();
